import { QuoteLeg } from './legModels';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses';
import { ErrorDetails } from 'acscp/api/models/errorDetails';

export enum RequestStatus {
    Success,
    Failed,
    InProgress,
}

export interface RequestError extends ErrorDetails {
    responseType: ResponseErrorTypes | ResponseType.Fatal;
}

export interface Request {
    status: RequestStatus;
    lastError?: RequestError;
}

export interface RequestsState { [requestType: string]: Request; }

export function getRequestsStateKey(requestType: string, callerId?: string): string {
    if (callerId) {
        return `${requestType}.${callerId}`;
    }
    return requestType;
}

export function requestsStateKeyMatchesRequestType(key: string, requestType: string): boolean {
    return key === requestType
        || key.startsWith(requestType + '.');
}
